// Mirrors apps/api/src/utils/chatSides.js. Keep the two in sync.
const isAdminSide = (role?: string | null) =>
  ['ADMIN', 'ADMIN_STAFF'].includes(String(role ?? '').toUpperCase())

// True when the actor is on the OTHER side from the viewer, i.e. the actor has
// just read the viewer's own messages. False when either role is unknown, so an
// unidentifiable event never moves the tick.
export const isOppositeSide = (viewerRole?: string | null, actorRole?: string | null) =>
  !!viewerRole && !!actorRole && isAdminSide(viewerRole) !== isAdminSide(actorRole)
